/**
 * Shared 1-4 severity scale for badges: business importance today, risk
 * level later (see docs/design-guidelines.md "Open questions" — Level-color
 * scale). Same hue family (red) ramps in intensity for High vs Very High
 * rather than introducing a 4th hue, since this app's category-accent
 * palette only reserves emerald/amber/red for this kind of status meaning.
 */
export const LEVEL_LABELS: Record<1 | 2 | 3 | 4, string> = {
  1: "Low",
  2: "Medium",
  3: "High",
  4: "Very High",
};

export const LEVEL_BADGE_CLASSES: Record<1 | 2 | 3 | 4, string> = {
  1: "border-emerald-200 bg-emerald-100 text-emerald-700",
  2: "border-amber-200 bg-amber-100 text-amber-700",
  3: "border-red-200 bg-red-100 text-red-700",
  4: "border-red-700 bg-red-600 text-white",
};
